import {
    loginAction,
    checkUserAction,
    logoutAction,
    refreshTokenAction,
} from './authAction';
import {
    dataUserAction,
    createUserAction,
    deleteUserAction,
    getUpdateUserAction,
    updateUserAction,
    updateForceMfaAction,
    getRoleUserAction,
    changePasswordUserAction,
} from './userAction';
import {
    getListRoomTypes,
    setListRoomTypes,
    getRoomType,
    setRoomType,
    saveRoomType,
    saveRoomTypeSuccess,
} from './roomTypeAction';
import {
    getListHomestayRoomTypes,
    setListHomestayRoomTypes,
    getHomestayRoomType,
    setHomestayRoomType,
    saveHomestayRoomType,
    saveHomestayRoomTypeSuccess,
} from './homestayRoomTypeAction';
import {
    getListLocations,
    setListLocations,
    getLocation,
    setLocation,
    saveLocation,
    saveLocationSuccess,
    deleteLocation,
    deleteLocationSuccess
} from './locationAction';
import {
    getListPopularPlaces,
    setListPopularPlaces,
} from './popularPlaceAction';

import {
    dataPropertyAction,
    createPropertyAction,
    deletePropertyAction,
    getUpdatePropertyAction,
    dataAllPropertyAction,
    updatePropertyAction,
} from './propertyAction';
import {
    uploadAction,
    uploadReset,
} from './uploadAction';
import {
    dataBannerAction,
    createBannerAction,
    deleteBannerAction,
    getUpdateBannerAction,
    updateBannerAction,
} from './bannerAction';
import {
    createTourAction,
    dataTourAction,
    getUpdateTourAction,
    deleteTourAction,
    updateTourAction,
    createTourLineAction,
    deleteTourLineAction,
    updateTourLineAction,
    createMultipleTourLineAction,

} from './tourAction';
import {
    dataOrderAction,
    getOrderItemAction,
    getItemVoucherOrderAction,
    getDetailVoucherOrderAction,
    getInfoVoucherDetailGroupAction,
    reSendEmailOrderAction,
    exportSaleOrderVoucherAction,
    getOrderDetail,
    exportExcel as exportExcelOrder,
    repushAffiliateAction,
} from './orderAction';
import {
    dataCustomerAction,
    exportCustomerAction,
    getCustomerAction,
    updateCustomerAction,
    filterGetAllCustomerAction,
} from './customerAction';
import {
    dataGroupAction,
    createGroupAction,
    deleteGroupAction,
    cloneGroupAction,
    getUpdateGroupAction,
    updateGroupAction,
    importGroupAction,
    exportGroupAction,
    dataAllGroupAction,
    exportVoucherGroupAction,
    resetGroup,
} from './groupAction';
import {
    dataProductAction,
    createProductAction,
    deleteProductAction,
    getUpdateProductAction,
    dataAllProductAction,
    updateProductAction,
} from './productAction';
import {
    dataVoucherAction,
    checkVoucherAction,
    usedVoucherAction,
    exportVoucherAction,
    importVoucherAction,
    voucherReset,
    createVoucherAction,
    getItemVoucherAction,
    getHistoryVoucherAction,
    updateVoucherAction,
    checkVoucherFailAction,
    exportExcel as exportExcelVoucher,
} from './voucherAction';
import {
    dataRoleAction,
    dataAllRoleAction,
    dataRolePremissionAction,
    getUpdateRoleAction,
    createRoleAction,
    deleteRoleAction,
    updateRoleAction,
} from './roleAction';

import {
    getPriceConfigBeachVilla,
    createPriceConfigBeachVilla,
    updatePriceConfigBeachVilla,
} from './rateAction';

import * as Setting from './settingAction';
import * as Tag from './tagAction';
import * as Inventory from './inventoryAction';
import * as VinwonderTagGroup from './vinwonderTagGroupAction';
import * as cacheRedisAction from './cacheRedisAction';


export default {
    getRoomType,
    setRoomType,
    getListRoomTypes,
    setListRoomTypes,
    saveRoomType,
    saveRoomTypeSuccess,
    getHomestayRoomType,
    setHomestayRoomType,
    getListHomestayRoomTypes,
    setListHomestayRoomTypes,
    saveHomestayRoomType,
    saveHomestayRoomTypeSuccess,
    getListLocations,
    setListLocations,
    getLocation,
    setLocation,
    saveLocation,
    saveLocationSuccess,
    deleteLocation,
    deleteLocationSuccess,
    getListPopularPlaces,
    setListPopularPlaces,
    dataUserAction,
    createUserAction,
    deleteUserAction,
    getUpdateUserAction,
    updateUserAction,
    updateForceMfaAction,
    getRoleUserAction,
    changePasswordUserAction,
    loginAction,
    checkUserAction,
    logoutAction,
    refreshTokenAction,
    dataPropertyAction,
    createPropertyAction,
    deletePropertyAction,
    getUpdatePropertyAction,
    dataAllPropertyAction,
    updatePropertyAction,
    uploadAction,
    uploadReset,
    dataBannerAction,
    createBannerAction,
    deleteBannerAction,
    getUpdateBannerAction,
    updateBannerAction,
    createTourAction,
    dataTourAction,
    getUpdateTourAction,
    deleteTourAction,
    updateTourAction,
    createTourLineAction,
    deleteTourLineAction,
    updateTourLineAction,
    //Order
    dataOrderAction,
    getOrderDetail,
    exportExcelOrder,
    getOrderItemAction,

    createMultipleTourLineAction,
    dataProductAction,
    createProductAction,
    deleteProductAction,
    getUpdateProductAction,
    dataAllProductAction,
    updateProductAction,
    dataCustomerAction,
    exportCustomerAction,
    getCustomerAction,
    updateCustomerAction,
    filterGetAllCustomerAction,
    dataGroupAction,
    createGroupAction,
    deleteGroupAction,
    cloneGroupAction,
    getUpdateGroupAction,
    updateGroupAction,
    importGroupAction,
    exportGroupAction,
    dataAllGroupAction,

    //Voucher
    exportVoucherGroupAction,
    resetGroup,
    dataVoucherAction,
    checkVoucherAction,
    usedVoucherAction,
    exportVoucherAction,
    importVoucherAction,
    voucherReset,
    createVoucherAction,
    getItemVoucherAction,
    getHistoryVoucherAction,
    updateVoucherAction,
    checkVoucherFailAction,
    exportExcelVoucher,

    getItemVoucherOrderAction,
    getDetailVoucherOrderAction,
    getInfoVoucherDetailGroupAction,
    reSendEmailOrderAction,
    exportSaleOrderVoucherAction,
    dataRoleAction,
    dataAllRoleAction,
    dataRolePremissionAction,
    getUpdateRoleAction,
    createRoleAction,
    deleteRoleAction,
    updateRoleAction,
    Setting,
    Tag,
    Inventory,
    repushAffiliateAction,
    getPriceConfigBeachVilla,
    createPriceConfigBeachVilla,
    updatePriceConfigBeachVilla,
    VinwonderTagGroup,
    cacheRedisAction
}
